import { render, staticRenderFns } from "./autoPartesAdd.vue?vue&type=template&id=20300bf8"
import script from "./autoPartesAdd.vue?vue&type=script&lang=js"
export * from "./autoPartesAdd.vue?vue&type=script&lang=js"
import style0 from "./autoPartesAdd.vue?vue&type=style&index=0&id=20300bf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports